import request from "@/utils/request";

const json = { "Content-Type": "application/json;charset=UTF-8" };
export const getNotifyEvents = () => request({ url: "/operation/notify/events", method: "get" });
export const getNotifyRules = () => request({ url: "/operation/notify/rules", method: "get" });
export const saveNotifyRule = data =>
  request({ url: "/operation/notify/rule/save", method: "post", data, headers: json });
export const deleteNotifyRule = id =>
  request({ url: `/operation/notify/rule/${id}/delete`, method: "post" });
export const getNotifyRobots = () => request({ url: "/operation/notify/robots", method: "get" });
export const saveNotifyRobot = data =>
  request({ url: "/operation/notify/robot/save", method: "post", data, headers: json });
export const deleteNotifyRobot = id =>
  request({ url: `/operation/notify/robot/${id}/delete`, method: "post" });
export const testNotifyRobot = id =>
  request({ url: `/operation/notify/robot/${id}/test`, method: "post" });
export const getNotifyGroups = () => request({ url: "/operation/notify/groups", method: "get" });
export const saveNotifyGroup = data =>
  request({ url: "/operation/notify/group/save", method: "post", data, headers: json });
export const deleteNotifyGroup = id =>
  request({ url: `/operation/notify/group/${id}/delete`, method: "post" });
export const getNotifyRecords = params =>
  request({ url: "/operation/notify/records", method: "get", params });
export const retryNotifyRecord = id =>
  request({ url: `/operation/notify/record/${id}/retry`, method: "post" });
